import { useEffect, useState } from 'react';
import TreeStructure from './TreeStructure';
import { TreeNode } from './types/types';
import { UploadButton } from './UploadButton';

const MainPage = () => {
  const [data, setData] = useState<TreeNode[] | undefined>(undefined);
  const [file, setFile] = useState<string | ArrayBuffer | null | undefined>(
    undefined
  );

  useEffect(() => {
    if (file) {
      setData(JSON.parse(file.toString()));
    }
  }, [file]);

  return (
    <div className='center'>
      <img src='/logo-primary-white.svg' alt='Optimify' />
      <div className='content'>
        {data ? (
          <TreeStructure nodes={data} />
        ) : (
          <div>
            <UploadButton setData={setFile} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainPage;
